import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { CatalogType, CatalogVisibilityRule, OrderApprovalRule } from '@app/models/products';

import { IFormValues } from '../interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    name: Yup.string().required(t('required')),
    start_date: Yup.string().nullable(),
    end_date: Yup.string().nullable(),
    warehouse: Yup.object({
      value: Yup.string(),
      label: Yup.string(),
    }).nullable(),
    process_uid: Yup.string(),
    catalog_type: Yup.mixed<CatalogType>(),
    project_uid: Yup.string().nullable(),
    media: Yup.array(),

    visibility_rule: Yup.mixed<CatalogVisibilityRule>().required(t('required')),
    product_uids: Yup.array(),
    visible_to_user_group_uids: Yup.array().required(t('required')),
    visible_to_users: Yup.array()
      .of(
        Yup.object({
          value: Yup.number().defined().required(t('required')),
          label: Yup.string(),
        }).defined()
      )
      .defined()
      .min(1, t('required'))
      .required(t('required')),
    order_approval_rule: Yup.mixed<OrderApprovalRule>().required(t('required')),
    show_multiplicity_indicator: Yup.boolean(),
    // order_approval_chain_id: Yup.string().test('isRequired', '123', (val, context) => {
    //   return context.parent.order_approval_rule === OrderApprovalRule.OrderApprovalChain && !val;
    // }),
    order_approval_chain_uid: Yup.string(),
    order_approval_chain_name: Yup.string(),
  });
